import React, { Component } from 'react';
import { connect } from 'dva';
import { Tooltip, Popconfirm, Icon, Badge } from 'antd';
import OperateDropdown from '../../../../../../../components/OperateDropdown';
import ListPage from '../../../../../../../components/ListPage';

const { ListTable } = ListPage;

const statusText = {
  0: '使用中',
  1: '未使用',
};
const statusColor = {
  0: '#1785EC',
  1: 'rgba(0, 0, 0, 0.25)',
};

@connect(({ labelSetting, user }) => {
  return {
    currentUser: user.currentUser,
    ...labelSetting,
  };
})
class TableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderAction = record => {
    const { dispatch, deleteGroup, orderSwitch } = this.props;

    const data = [
      {
        text: <a onClick={() => {
          dispatch({
            type: 'labelSetting/saveState',
            payload: { modalTitle: '编辑分组', modalVisible: true, formData: record },
          });

        }}>编辑</a>,
      },
      {
        text: <a onClick={() => orderSwitch(record, 'on')}>批量启用</a>,
      },
      {
        text: <a onClick={() => orderSwitch(record, 'off')}>批量禁用</a>,
      },
      {
        text: (
          <Popconfirm title="是否确认要删除？" placement="top" okText="确定" cancelText="取消" onConfirm={() => deleteGroup(record)}>
            <a>删除</a>
          </Popconfirm>
        ),
      },
    ];

    return data;
  };

  renderSysAction = record => {
    const { orderSwitch } = this.props || {};

    return [
      {
        text: <a onClick={() => orderSwitch(record, 'on')}>批量启用</a>,
      },
      {
        text: <a onClick={() => orderSwitch(record, 'off')}>批量禁用</a>,
      },
    ];
  };

  renderLabelAction = record => {
    const { fetchSubmit, deleteLabel, dispatch } = this.props;
    const data = [
      {
        text: <a onClick={() => {
          dispatch({
            type: 'labelSetting/saveState',
            payload: { modalTitle: '编辑分组', modalVisible: true, formData: record },
          });

        }}>编辑</a>,
      },
      {
        text: <a onClick={() => fetchSubmit(record)}>{record.status === 0 ? '禁用' : '启用'}</a>,
      },
      {
        text: (
          <Popconfirm
            title="是否确认要删除？"
            placement="top"
            okText="确定"
            cancelText="取消"
            onConfirm={() => deleteLabel(record)}
          >
            <a>删除</a>
          </Popconfirm>
        ),
      },
    ];

    return data;
  };

  changePage = (page, pageSize) => {
    const { params, pageChange } = this.props;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    pageChange(tempParams)

  };

  render() {
    const { dataSource, totalElements, params, isGroup, currentTagData, fetchSubmit } = this.props;
    const { page } = params;
    const groupColumn = [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '标签数',
        dataIndex: 'count',
        key: 'count',
      },
      {
        title: '类型',
        dataIndex: 'groupType',
        key: 'groupType',
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          if (record.groupType === '系统') {
            // return '-'
            return <OperateDropdown data={this.renderSysAction(record)} />;
          }
          return <OperateDropdown data={this.renderAction(record)} />;
        },
      },
    ];
    const labelColumns = [
      {
        title: '标签名称',
        dataIndex: 'label',
        key: 'label',
        width: 300,
      },
      {
        title: (
          <div>
            审批人{'  '}
            <Tooltip
              placement="top"
              title="学校上报资讯时，可以根据学校选择的标签设置不同的审批人员，选择多标签则任意标签下审批人均可审批，未选择标签时默认所有的宣传管理管理员均可审批"
            >
              <Icon type="question-circle" />
            </Tooltip>
          </div>
        ),
        dataIndex: 'audit',
        key: 'audit',
        render: text => {
          if (text && text.length) {
            return (
              <Tooltip
                placement="top"
                title={text.map((item, index) => (
                  <span>
                    {item.username}
                    {index !== text.length - 1 ? '、' : ''}{' '}
                  </span>
                ))}
              >
                <span>{text.length > 1 ? `${text[0].username}...` : text[0].username}</span>
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return <Badge color={statusColor[text]} text={statusText[text]} />;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          if (currentTagData && currentTagData.groupType && currentTagData.groupType === '系统') {
            // return '-'
            return <a onClick={() => fetchSubmit(record)}>{record.status === 0 ? '禁用' : '启用'}</a>
          }
          return <OperateDropdown data={this.renderLabelAction(record)} />;
        },
      },
    ];

    const tableProps = {
      pageInfo: { totalElements, page },
      columns: isGroup ? groupColumn : labelColumns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    return <ListTable {...tableProps} />;
  }
}

export default TableList;
